import {FWU_ERROR_CODES} from '../../consts/fwu/fwuErrorCodes';
import helpers from '../../utils/helpers';
import BaseFwuClient from './baseFwuClient';
import {log} from '../log';
import DeviceFwuCharacteristicClient from './deviceFwuCharacteristicClient';

const FWU_MAX_RETRY_COUNT = 5;
let instance = null;

export default class DeviceFwuClient extends BaseFwuClient {
    constructor(options) {
        if (options && instance) {
            instance.stop();
            instance = null;
        }

        if (instance) {
            return instance;
        }
        if (!options) {
            throw new Error('DeviceFwuClient is not initialized');
        }

        super({fwuPackageData: options.fwuPackageData, fwuTarget: options.fwuTarget});
        instance = this;
        this.currentFwuTry = 0;
        this.deviceFwuCharacteristicClient = undefined;
        this.onFwuError = options?.onFwuError;
        this.onFwuStatusEvent = options?.onFwuStatusEvent;
        this.onFwuFinish = options?.onFwuFinish;
    }

    stop = () => {
        if (this.deviceFwuCharacteristicClient) {
            this.deviceFwuCharacteristicClient.stop();
            this.deviceFwuCharacteristicClient = undefined;
            this.onFwuStopBase();
        }
    };

    startFwUpdate = async () => {
        this.setStartTs();

        //TODO: remove DeviceFwuCharacteristicClient
        this.deviceFwuCharacteristicClient = new DeviceFwuCharacteristicClient({
            fwuPackageData: this.fwuPackageData,
            canRetry: this.currentFwuTry <= FWU_MAX_RETRY_COUNT,
            sendStatusMessage: this.sendStatusMessage,
            onUpgradeProcessing: () => {
                this.onFwuFinishBase();
            },
            retryToUpdateFW: async () => {
                log.debug(`DeviceFwuClient: try to start FWU again: try #${this.currentFwuTry}`);
                this.currentFwuTry = this.currentFwuTry + 1;
                await helpers.timeout(500);
                await this.startFwUpdate();
            },
            onErrorWithoutRetry: ({lastRequestFrames, lastResponseFrames}) => {
                this.onFwuErrorBase({errorCode: FWU_ERROR_CODES.GENERAL, lastRequestFrames, lastResponseFrames});
            },
        });
    };
}
